module.exports = __webpack_public_path__ + "media/images/faces/face21-69f2c660249432d86ad305f1b292269c.jpg";